module.exports = __webpack_public_path__ + "static/img/1-active.3c94355.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/1-active.png
// module id = sCrr
// module chunks = 0